const Pill = ({ children, color = "bg-[#F5F3F0] text-zinc-500" }) => (
  <span
    className={`absolute border-[#DCDBD6] tracking-widest top-1.5 right-1.5 z-10 text-[7px] font-normal px-1.5 py-[4px] border rounded-[3px] ${color}`}
  >
    {children}
  </span>
);

export default Pill;
